import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/contexts/AuthContext'
import { ownAccountReference } from '@/services/vault/subjectVerifications'
import { Field } from './VaultForms'

export default function AccountReference() {
  const { user } = useAuth()
  if (user?.authScope !== 'client_vault') return null
  return <Reference key={JSON.stringify([user.id, user.currentSessionId, user.role])} />
}
function Reference() {
  const { user } = useAuth()
  const [message, setMessage] = useState('')
  const current = useQuery({
    queryKey: ['vault-account-reference', user?.id, user?.currentSessionId],
    queryFn: () => ownAccountReference(user!.id),
    staleTime: 0,
  })
  const reference = !current.isFetching && !current.isError ? current.data : undefined
  return (
    <section
      className="border border-surface-overlay rounded-lg p-4 space-y-3"
      aria-label="Independent account reference"
    >
      <h2 className="font-semibold">Your account reference</h2>
      <p className="text-sm text-text-secondary">
        Share this reference if a firm needs to nominate you for legal-subject verification. It
        identifies your account; your authority and acceptance must be verified separately.
      </p>
      {current.isFetching && <p role="status">Checking your current account…</p>}
      {current.isError && <p role="alert">{current.error.message}</p>}
      {reference && (
        <>
          <Field
            label="Current account reference"
            value={reference}
            readOnly
            onFocus={event => event.target.select()}
          />
          <button
            className="btn btn-secondary"
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(reference)
                setMessage('Account reference copied.')
              } catch {
                setMessage('Select the reference and copy it.')
              }
            }}
          >
            Copy account reference
          </button>
        </>
      )}
      {message && reference && <p role="status">{message}</p>}
    </section>
  )
}
